import React from "react";
import "../css/home.less";
import { getImageUrl } from "../config";
import TweenOne from "rc-tween-one";
import QueueAnim from "rc-queue-anim";
import RcScrollOverPack from "rc-scroll-anim/lib/ScrollOverPack";
import useNarrowViewport from "../common/useNarrowViewport";
import { useLocalizedNavigate } from "../components/LocalizedLink";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

const SubHome1: React.FC = () => {
  const { t } = useTranslation();
  const narrow = useNarrowViewport();
  const navigate = useLocalizedNavigate();

  const handleLinkTo = () => {
    navigate("/service");
    window.scrollTo(0, 0);
  };

  return (
    <RcScrollOverPack id="top-strength" className="homepage">
      <QueueAnim
        duration={450}
        type="left"
        className="home-title"
        key="title"
        leaveReverse
      >
        <h2 key="h2" className="home-title-ja-lg">{t("home.strength_title")}</h2>
        <p className="home-title-en-lg" key="home-title-en-lg">Strength</p>

        <p className="strength-content__description">{t("home.strength_sub")}</p>
      </QueueAnim>

      <TweenOne
        key="content"
        className="strength-content"
        animation={{ x: 0, opacity: 1, ease: "easeOutQuad" }}
        style={{
          transform: `translateX(${narrow ? 0 : 100}px)`,
          opacity: 0,
        }}
      >
        <div className="strength-content__wrapper">
          <div className="strength-content__main">
            <div className="home-content-item-image">
              <img src={getImageUrl("/image/top-strength01.png")} alt="strength_1" />
            </div>
            <div className="strength-content__list">
              <div className="strength-content__list__item">
                <div className="strength-content__list__item__num"><img src={getImageUrl("/image/top-strength-num01.png")} alt="strength_1" /></div>
                <div className="strength-content__list__item__title">
                  {t("service_page.st1_line1")}<br />
                  {t("service_page.st1_line2")}
                </div>
                <div className="strength-content__list__item__img">
                  <img src={getImageUrl("/image/top-strength-img01.png")} alt="arrow_1" />
                </div>
              </div>

              <div className="strength-content__list__item">
                <div className="strength-content__list__item__num"><img src={getImageUrl("/image/top-strength-num02.png")} alt="strength_1" /></div>
                <div className="strength-content__list__item__title">
                  {t("service_page.st2_line1")}<br />
                  {t("service_page.st2_line2")}
                </div>
                <div className="strength-content__list__item__img">
                  <img src={getImageUrl("/image/top-strength-img02.png")} alt="arrow_1" />
                </div>
              </div>

              <div className="strength-content__list__item">
                <div className="strength-content__list__item__num"><img src={getImageUrl("/image/top-strength-num03.png")} alt="strength_1" /></div>
                <div className="strength-content__list__item__title">
                  {t("service_page.st3_line1")}<br />
                  {t("service_page.st3_line2")}
                </div>
                <div className="strength-content__list__item__img">
                  <img src={getImageUrl("/image/top-strength-img03.png")} alt="arrow_1" />
                </div>
              </div>
            </div>
          </div>

          <p className="strength-content__bottom-description">{t("home.strength_bottom")}</p>

          <Button
            type="primary"
            className="strength-content__cta-btn"
            size="large"
            onClick={handleLinkTo}
          >
            {t("home.more_details")}
          </Button>

        </div>
      </TweenOne>
    </RcScrollOverPack >
  );
};

export default SubHome1;
